<template>
    <div>
        <base-header :type="gradientType" class="pb-6 pb-8 pt-5 pt-md-8">
            <base-dropdown v-if="activeModules.length > 1">
                <base-button slot="title" :type="buttonType" class="dropdown-toggle">
                    Supercard Profiles - {{ _.startCase(currentProfile) }}
                </base-button>
                <a v-for="profile in activeModules" :key="profile.id"
                    @click.prevent="setCurrentProfile(_.pluralize(_.snakeCase(profile.name)), profile.id)"
                    class="dropdown-item" href="#">{{ profile.name }}</a>
            </base-dropdown>
            <!-- <base-dropdown v-else>
               <base-button slot="title" type="primary" class="dropdown-toggle">
                 Advanced Profiles
               </base-button> 
               <a class="dropdown-item" disabled>No active module/s under this feature</a>
            </base-dropdown> -->
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card mb-3">
                        <div class="row no-gutters">
                            <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
                                <div class="card-body">
                                    <filter-bar @changeFilter="changeFilter"></filter-bar>

                                </div>
                            </div>
                            <div class="col-md-9">
                                <div class="card-body">
                                    <supercard-profiles-table :key="formKey"
                                        :accessRights="accessRights"></supercard-profiles-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>


<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import SupercardProfilesTable from '../Tables/SupercardProfilesTable.vue'
import FilterBar from './../FilterBar'
import { mapState, mapActions } from 'vuex'
import secureStorage from '../../controllers/secureStorage';

export default {
    data: function () {
        return {
            formKey: 0,
            activeModules: [],
            accessRights: [],
            gradientType: "instore",
            buttonType: "danger"
        }
    },
    watch: {
        $route: async function (to, from) {
            await this.loadPage();
        }
    },
    mounted: async function () {
        this.loadPage()
    },
    computed: {
        ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
    },
    components: {
        SupercardProfilesTable, FilterBar
    },
    methods: {
        ...mapActions(['updateCurrentProfile', 'updateParameters']),
        async loadPage() {
            // var providedFilter = this.$route.query.type
            // console.log(providedFilter)

            // if(providedFilter.includes("U-"))
            //     var categoryId = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories?code=UM-001', null, null)
            // else if(providedFilter.includes("UG-"))
            //     var categoryId = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories?code=UM-002', null, null)
            // else
            var categoryId = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories?code=MDM-006', null, null)

            this.activeModules = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories/' + categoryId[0].id + '/enabled_modules', null, null)


            if (this.activeModules.length > 0) {
                var profile = _.snakeCase(this.activeModules[0].name)
                this.setCurrentProfile(_.pluralize(profile), this.activeModules[0].id);
            } else {
                this.setCurrentProfile(null, null);
                this.formKey++
            }

            // if(providedFilter.includes("U-") || providedFilter.includes("UG-")){
            //     this.gradientType = "instore"
            //     this.buttonType = "danger"
            // }
            // else{
            this.gradientType = "instore"
            this.buttonType = "success"
            // }

        },
        async setCurrentProfile(profile, id) {
            // this.profileId = id
            var accessRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + id, null)
            if (_.isEmpty(accessRightsRequest.access_rights) == false) {
                this.accessRights = accessRightsRequest.access_rights[id]
            } else {
                this.accessRights = []
            }
            this.updateCurrentProfile(profile)
            // this.statusKey++;
            this.formKey++;
            // this.updateCurrentProfile(profile)
        },
        changeFilter(statusFilter, searchFilter, searchText) {
            if (statusFilter == "0") {
                this.updateParameters("?" + searchFilter + "=" + searchText)
            } else if (statusFilter == "A") {
                this.updateParameters("?" + searchFilter + "=" + searchText + "&status=A")
            } else {
                this.updateParameters("?" + searchFilter + "=" + searchText + "&status=I")
            }
        },
    }
};
</script>


<style></style>
